import { type ContactAircraftVisibilityLimitations } from '../Contacts/ContactAircraftVisibilityLimitations';

type BaseUser = {
    name: string;
    userId: string;
    aircraftId?: string;
    crewId?: string;
    contactId?: string;
    hasDutyTracking?: boolean;
};
type AircraftUser = BaseUser & {
    aircraftId: string;
};

export type ContactUser = BaseUser & {
    crewId: string;
    contactId: string;
    hasDutyTracking: boolean;
    isReservationResource: boolean;
    aircraftVisiblityLimitations: ContactAircraftVisibilityLimitations | null;
    fullReadAccessToAircrafts: string[] | null;
    baseAirportIcaos: string[];
    hasAccessToCustomerDatabase: boolean;
};

export type User = AircraftUser | ContactUser;

export const userIsCrew = (user: User): user is ContactUser => user.crewId !== undefined;

export const userIsContact = (user: User): user is ContactUser => user.contactId !== undefined;
